import React, { useState, useEffect } from 'react';
import axios from 'axios';
import WebpagesFolderTree from './WebpagesFolderTree.jsx';

export default function WebpagesBulkActionsModal({
  isOpen,
  mode,
  onClose,
  onSubmit,
  folders
}) {
  const [value, setValue] = useState('');
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [templatesError, setTemplatesError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setValue('');
      setSelectedFolderId(null);
      setTemplatesError('');
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    if (mode !== 'set_template') return;

    let isCancelled = false;

    const loadTemplates = async () => {
      setLoadingTemplates(true);
      setTemplatesError('');
      try {
        const { data } = await axios.get('/api/v1/webpages/templates-options');
        const items = (data && data.success && Array.isArray(data.data)) ? data.data : [];
        if (!isCancelled) {
          setTemplates(items);
        }
      } catch (e) {
        if (!isCancelled) {
          setTemplates([]);
          setTemplatesError(e?.response?.data?.error || 'Failed to load templates');
        }
      } finally {
        if (!isCancelled) setLoadingTemplates(false);
      }
    };

    loadTemplates();

    return () => {
      isCancelled = true;
    };
  }, [isOpen, mode]);

  if (!isOpen) return null;

  let title = '';
  let content = null;

  const handleSubmit = () => {
    if (mode === 'move_folder') {
      if (selectedFolderId) onSubmit(selectedFolderId);
    } else {
      if (value) onSubmit(value);
    }
  };

  switch (mode) {
    case 'add_tag':
      title = 'Add Tag';
      content = (
        <input
          type="text"
          className="form-control"
          placeholder="Tag name"
          value={value}
          onChange={e => setValue(e.target.value)}
          autoFocus
          onKeyDown={e => { if (e.key === 'Enter') handleSubmit(); }}
        />
      );
      break;
    case 'remove_tag':
      title = 'Remove Tag';
      content = (
        <input
          type="text"
          className="form-control"
          placeholder="Tag name"
          value={value}
          onChange={e => setValue(e.target.value)}
          autoFocus
          onKeyDown={e => { if (e.key === 'Enter') handleSubmit(); }}
        />
      );
      break;
    case 'set_template':
      title = 'Set Template';
      content = (
        <div>
          {templatesError ? <div className="alert alert-danger" style={{ marginBottom: 10 }}>{templatesError}</div> : null}
          {loadingTemplates ? <div className="text-muted" style={{ marginBottom: 6 }}>Loading templates…</div> : null}
          <select
            className="form-control"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            autoFocus
          >
            <option value="">Select template…</option>
            {(templates || []).map((t) => (
              <option key={String(t.id)} value={String(t.id)}>
                {t.title}{t.tid ? ` (${t.tid})` : ''}{String(t.active) === '1' ? '' : ' [inactive]'}
              </option>
            ))}
          </select>
        </div>
      );
      break;
    case 'move_folder':
      title = 'Move to Folder';
      content = (
        <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px', backgroundColor: '#fff' }}>
          <WebpagesFolderTree
            folders={folders}
            selectedId={selectedFolderId}
            onSelect={(node) => setSelectedFolderId(node.id)}
          />
        </div>
      );
      break;
    default:
      return null;
  }

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 2000,
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div className="panel panel-default" style={{ width: '400px', maxWidth: '90%', boxShadow: '0 5px 15px rgba(0,0,0,0.5)' }}>
        <div className="panel-heading">
          <h3 className="panel-title">{title}</h3>
        </div>
        <div className="panel-body">
          {content}
        </div>
        <div className="panel-footer text-right">
          <button className="btn btn-default" onClick={onClose} style={{ marginRight: '10px' }}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
        </div>
      </div>
    </div>
  );
}
